import { Controller } from "@hotwired/stimulus"

// Keeps quantity options in sync with the selected size's available stock
export default class extends Controller {
  static targets = ["sizeSelect", "quantitySelect"]

  static values = {
    stock: Object,
    maxQuantity: { type: Number, default: 10 }
  }

  connect() {
    this.updateQuantityOptions()
  }

  updateQuantityOptions() {
    if (!this.hasSizeSelectTarget || !this.hasQuantitySelectTarget) return

    const selectedSizeId = this.sizeSelectTarget.value
    const availableStock = parseInt(this.stockValue?.[selectedSizeId] ?? 0, 10)
    const maxQuantity = Math.min(
      Math.max(availableStock, 0),
      this.maxQuantityValue || 10
    )
    const previousSelection = parseInt(this.quantitySelectTarget.value, 10)
    const desiredSelection = Number.isNaN(previousSelection)
      ? 1
      : previousSelection

    this.quantitySelectTarget.innerHTML = ""

    if (maxQuantity === 0) {
      this.disableQuantitySelect()
      return
    }

    for (let index = 1; index <= maxQuantity; index += 1) {
      const option = document.createElement("option")
      option.value = index
      option.textContent = index

      if (index === Math.min(desiredSelection, maxQuantity)) {
        option.selected = true
      }

      this.quantitySelectTarget.appendChild(option)
    }

    this.quantitySelectTarget.disabled = false
  }

  disableQuantitySelect() {
    this.quantitySelectTarget.disabled = true
    const option = document.createElement("option")
    option.value = ""
    option.textContent = "Out of stock"
    option.disabled = true
    option.selected = true
    this.quantitySelectTarget.appendChild(option)
  }
}
